<template>
  <div :class="`lead${$theme?'':' eng'}`">
    <div class="bottom"></div>
    <div class="title">
      <span>{{ $theme ? '奠基科技时代的领袖护航' : 'ESCORTED THE LEADERS SETTING STAGE FOR THE TECHNOLOGY ERA' }}</span>
    </div>
<!--    <div v-if="$theme" class="subtitle">ESCORTED THE LEADERS SETTING STAGE FOR THE TECHNOLOGY ERA</div>-->
    <div class="doctors">
      <div class="doctor" v-for="doctor in doctors" :key="doctor.id">
        <div class="doctor-title"><span>{{ $theme ? doctor.title : doctor.titleEng }}</span></div>
        <vue-seamless-scroll
            :data="[1,2,3,4,5]"
            class="gun"
            :classOption="{
        step: 2,
        autoPlay: true,
        hoverStop: false,
        limitMoveNum: 1,
        direction: 2,
      }"
        >
          <div class="con">
            <span v-for="itm in 1000" :key="itm" class="text">{{ getName(doctor) }}</span>
          </div>
          <!--          <span v-for="(str, index) in getName(doctor)" :key="index">{{ str }}</span>-->
        </vue-seamless-scroll>
        <img :src="require(`@/assets/img/on-china-entropy/doctor/${doctor.id}.png`)"/>
        <div :class="`desc`" v-html="$theme?doctor.desc:doctor.descEng"></div>
      </div>
    </div>
    <vue-seamless-scroll
        :data="leaders"
        class="leaders"
        :classOption="{
        step: 4,
        autoPlay: true,
        limitMoveNum: 4,
        direction: 2,
      }"
    >
      <div class="img-wrap">
        <div class="img" v-for="(item, ind) in leaders"
             :key="ind + 'lead'">
          <img
              :src="require(`@/assets/img/on-china-entropy/leaders/${item}.png`)" alt=""/>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import VueSeamlessScroll from "vue-seamless-scroll";

export default {
  data() {
    return {
      doctors: [
        {
          id: 1,
          title: "Modem 发明人",
          titleEng: "Modem Inventor",
          name: "Dr. Richard D. Gitlin",
          descEng: 'Dr. Richard D. Gitlin<br>Former CTO of Bell Labs, American Academy of Engineering;<br>n the field of data communication, digital signal processing, wireless communication system has nearly 100 invention patents.',
          desc: 'Dr. Richard D. Gitlin<br>原贝尔实验室（Bell Labs）CTO 美国工程院院士；<br>在数据通信、数字信号处理、无线通信系统领域拥有近百项发明专利。'
        }, {
          id: 2,
          title: "数字通信奠基人",
          titleEng: "Founder of digital communications",
          name: "Dr. John G.Proakis",
          descEng: 'Dr. John G.Proakis<br>Founder and academic leader of contemporary digital communication, IEEE lifetime fellow;<br>The book "Digital Communication" became a widely used textbook and is known as the "Bible" of the industry.',
          desc: 'Dr. John G.Proakis<br>当代数字通信的奠基者和学术领袖、IEEE终身院士；<br>编撰的《数字通信》成为广泛使用的教科书，被誉为行业的“圣经”。'
        }, {
          id: 3,
          title: "蓝牙之父",
          titleEng: "The Father of Bluetooth",
          name: "Dr. David L.Lyon",
          descEng: 'Dr. David L.Lyon<br>Bachelor, master and PhD in Electrical Engineering from Massachusetts Institute of Technology (MIT);<br>The founder of the Bluetooth standard and designed the first Bluetooth SOC chip.',
          desc: 'Dr. David L.Lyon<br>麻省理工学院（MIT）获电气工程专业本、硕、博士学位；<br>蓝牙标准的奠基人并设计了第一枚蓝牙SOC芯片。'
        }, {
          id: 4,
          title: "数字滤波领路人",
          titleEng: "Digital Filtering Leader",
          name: "Dr. James R.Zeidler",
          descEng: 'Dr. James R.Zeidler<br>Professor Zeidler\'s research areas include digital signal and image processing,<br>and the application, performance, and implementation of adaptive algorithms.',
          desc: 'Dr. James R.Zeidler<br>Zeidler教授的研究领域包括数字信号和图像处理，<br>以及自适应算法的应用、性能和实现。'
        },
      ],
      leaders: [
        1, 2, 3, 4, 5, 6
      ],
    };
  },
  props: {},
  components: {
    VueSeamlessScroll
  },
  computed: {},
  methods: {
    getName(doctor) {
      const {name} = doctor
      return name
      // let str = ''
      // for (let i = 0; i < 30; i++) {
      //   if (i > 0) {
      //     str += '  '
      //   }
      //   str = str.concat(name)
      // }
      // return str
    }
  },
  created() {
  },
  mounted() {
  },

};
</script>

<style scoped lang="scss">
@import "./Index.scss";
</style>
